module.exports = __webpack_public_path__ + "static/media/sub_vertical_icon.12ffcfcf.svg";